import type { FormColumn } from '@cli-types/core-engine/schema.js'
import { quoteLiteral } from '@cli-utils/text.js'
import { buildSortableHeaderDef } from '@next-adapter/generators/sortable-header/build-sortable-header-def.js'
import { buildColumnSize } from '@next-adapter/generators/table-column-size/build-column-size.js'
import { renderAdminColumnDefRenderer } from '@next-adapter/templates/renderers/generators/form-admin/admin-columns/generate-column-def.js'

export function generateColumnDef(col: FormColumn): string {
  const sortableHeader = col.sortable
    ? buildSortableHeaderDef(col.header)
    : `header: ${quoteLiteral(col.header)}`

  let cellDef: string
  switch (col.type) {
    case 'email':
      cellDef = renderAdminColumnDefRenderer({
        kind: 'renderColumnDefLayoutTemplate',
        props: { colAccessorKey: col.accessorKey }
      })
      break
    case 'date':
      cellDef = renderAdminColumnDefRenderer({
        kind: 'renderColumnDefDateTemplate',
        props: { colAccessorKey: col.accessorKey }
      })
      break
    case 'badge':
      cellDef = renderAdminColumnDefRenderer({
        kind: 'renderColumnDefValueTemplate',
        props: { colAccessorKey: col.accessorKey }
      })
      break
    case 'number':
      cellDef = renderAdminColumnDefRenderer({
        kind: 'renderColumnDefLayoutDetailsTemplate',
        props: { colAccessorKey: col.accessorKey }
      })
      break
    default:
      cellDef = renderAdminColumnDefRenderer({
        kind: 'renderColumnDefValueDetailsTemplate',
        props: { colAccessorKey: col.accessorKey }
      })
  }

  return renderAdminColumnDefRenderer({
    kind: 'renderColumnDefContentTemplate',
    props: {
      colAccessorKey: col.accessorKey,
      columnSize: buildColumnSize(col.size),
      sortableHeader: sortableHeader,
      cellDef: cellDef
    }
  })
}
